import React from "react";

const ATSLogo = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M33.458 30.773a2.26 2.26 0 0 1-3.178.247l-3.259-2.774a14.778 14.778 0 0 1-10.228 4.087C8.623 32.333 2 25.74 2 17.606c0-5.813 3.383-10.84 8.294-13.235-.499.98-.78 2.09-.78 3.265 0 .53.057 1.046.166 1.543a10.962 10.962 0 0 0-3.942 8.426c0 6.08 4.95 11.006 11.055 11.006 6.105 0 11.055-4.927 11.055-11.006 0-3.382-1.531-6.408-3.943-8.426a7.17 7.17 0 0 0 .166-1.543 7.193 7.193 0 0 0-.781-3.267c4.913 2.395 8.296 7.422 8.296 13.237a14.61 14.61 0 0 1-1.815 7.074l3.44 2.928a2.238 2.238 0 0 1 .247 3.165Z"
            fill="#007AFF"
        />
        <path
            d="M21.563 7.75c0 2.624-2.136 4.75-4.77 4.75-2.636 0-4.771-2.126-4.771-4.75 0-2.623 2.135-4.75 4.77-4.75s4.77 2.127 4.77 4.75Z"
            fill="#FFA700"
        />
        <path
            d="M25.748 17.364a8.881 8.881 0 0 1-3.024 6.696 8.944 8.944 0 0 1-5.844 2.237l-.433-.004-.438-.029a8.942 8.942 0 0 1-5.612-2.636 8.875 8.875 0 0 1-2.55-6.805.384.384 0 0 1 .122-.255l4.131-3.84 4.668 4.979 5.044-4.688 3.834 4.09a.373.373 0 0 1 .102.255Z"
            fill="#60B158"
        />
    </svg>
);

export default ATSLogo;